import { render, staticRenderFns } from "./AIConfig.vue?vue&type=template&id=06481f0d&scoped=true&lang=pug"
import script from "./AIConfig.vue?vue&type=script&lang=js"
export * from "./AIConfig.vue?vue&type=script&lang=js"
import style0 from "./AIConfig.vue?vue&type=style&index=0&id=06481f0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06481f0d",
  null
  
)

export default component.exports